import React from 'react';

import ResultsGroup from './ResultsGroup';

export default function SearchResults({ setModalOpen, searchResults }) {
  return (
    <div className="mb-3 last:mb-0">
      {Object.keys(searchResults)?.map?.((key) => {
        if (!searchResults[key]?.length) {
          return null;
        }

        return (
          <ResultsGroup
            id={key}
            title={key}
            setModalOpen={setModalOpen}
            searchResults={searchResults[key]}
          />
        );
      })}
    </div>
  );
}
